<template>
  <table
    cellspacing="0"
    class="profit-table-container"
  >
    <slot></slot>
  </table>
</template>
<script>
export default {
  name: 'ProfitTable',
  data() {
    return {
    };
  },
};
</script>
<style lang="scss" scoped>
.profit-table-container {
  font-size: 26px;
  table-layout: fixed;
  text-align: right;
  th {
    color: rgba(0,0,0,0.42);
    padding-bottom: 18px;
    min-width: 142px;
    &:first-child {
      text-align: left;
      position:sticky;
      left:0;
      background: #fff;
    }
  }

  td {
    padding: 18px 0;
    color: rgba(0,0,0,0.84);
    position:sticky;
    left:0;
    &:first-child {
      z-index: 1;
      background: #fff;
    }
  }
  tr {
    &:last-child {
      td {
        padding-bottom: 0;
      }
    }
  }
  .poi-name,.date-time {
    text-align: left;
    max-width: 225px;
    font-weight: bold;
    color: rgba(0,0,0,0.84);
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
  }
  .description-icon{
    &::after {
      position: absolute;
      margin-left: 9px;
    }
  }
  .status-tag {
    &::after {
      float: left;
    }
  }
  .icon-arrow{
    vertical-align: middle;
    display: inline-block;
    margin-top: -4px;
    margin-right: -8px;
    width: 24px;
    height: 24px;
  }
}
</style>
